module.exports = __webpack_public_path__ + "static/img/story_china.7b11723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/story_china.png
// module id = AkNJ
// module chunks = 1